let easyStepslider= new Swiper('.easy-steps-mobile-slider', {
                        slidesPerView: 1,
                        spaceBetween: 0,
                        pagination: {
                            el: ".swiper-pagination",
                            clickable: true,
                        }
                    });